export default __webpack_public_path__ + "static/media/icon-sms.984ed7c4.svg";